import DDNSStatus from '../components/DdnsStatus'

export default function Dashboard() {
  return (
    <div className="space-y-4 md:space-y-6">
      {/* 页面标题 */}
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-gray-900">
          控制面板
        </h1>
        <p className="text-sm text-gray-500 mt-1">欢迎回来，查看您的系统状态</p>
      </div>
      
      {/* DDNS 状态卡片 */}
      <DDNSStatus />
    </div>
  )
}
